import React, { FC } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import type { WithColor } from '@styles/colors';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';
import type { ImagesContainerProps } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';

import { AddImageIcon } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/AddImageIcon';

export interface FlatLineAddImageProps extends WithColor, Pick<ImagesContainerProps, 'flatLineBorderRadiusConfig' | 'bg'> {
  scale?: ScaleFunction;
  onPress: () => void;
}

export const FlatLineAddImage: FC<FlatLineAddImageProps> = ({
  C,
  flatLineBorderRadiusConfig,
  bg,
  scale = initialScale,
  onPress,
}) => (
  <View style={{ width: '100%', height: scale(98) }}>
    <TouchableElement testID={TEST_IDS.imagesContainer.emptyFlatLine} onPress={onPress}>
      {({ pressHoverColor, boxStyle }) => (
        <View
          style={[
            boxStyle,
            {
              width: '100%',
              height: scale(98),
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              backgroundColor: C(pressHoverColor(bg)),
              borderRadius: scale(SCREEN_BORDER_RADIUS),
              ...(flatLineBorderRadiusConfig ? flatLineBorderRadiusConfig : {}),
            },
          ]}
        >
          <AddImageIcon color={pressHoverColor('Link/Light/Primary')} scale={scale} />
        </View>
      )}
    </TouchableElement>
  </View>
);
